module.exports = __webpack_public_path__ + "img/China-2.e91d7a75.jpg";